import { render, staticRenderFns } from "./PivotHeaderCell.vue?vue&type=template&id=b6e2ded4&scoped=true"
import script from "./PivotHeaderCell.vue?vue&type=script&lang=js"
export * from "./PivotHeaderCell.vue?vue&type=script&lang=js"
import style0 from "./PivotHeaderCell.vue?vue&type=style&index=0&id=b6e2ded4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e2ded4",
  null
  
)

export default component.exports